import { useState, useEffect } from "react";
import * as Comp from "../../../Common/CommonComponents";

const PAllowanceRate = (props) => {
  const [tableData, setTableData] = useState([]);
  const [writeAuthority, setWriteAuthority] = useState(false);

  useEffect(() => {
    if (props.data !== undefined) {
      setTableData(props.data);
    }
    if (props.actionPermission !== undefined) {
      setWriteAuthority(props.actionPermission.WRITE === "Y");
    }
  }, [props.data]);

  function checkBoxHandler(row, val, featureType) {
    const newData = [...tableData];
    const no = newData[row.rowNo].PERMISSION_DETAILS.filter(
      (d) => d.FEATURE_TYPE === featureType
    ).map((f) => f.rowNo)[0];
    try {
      if (featureType !== "R" && val === true) {
        const detailR = newData[row.rowNo].PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "R"
        );
        if (
          detailR.length > 0 &&
          newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED ===
            "N"
        ) {
          var featureIdR = row.PERMISSION_DETAILS[detailR[0].rowNo].FEATURE_ID;
          props.ChangeFeaturePermission(featureIdR, val);
          newData[row.rowNo].PERMISSION_DETAILS[detailR[0].rowNo].AUTHORIZED =
            val === true ? "Y" : "N";
        }
      }
      var featureId = row.PERMISSION_DETAILS[no].FEATURE_ID;
      props.ChangeFeaturePermission(featureId, val);
      newData[row.rowNo].PERMISSION_DETAILS[no].AUTHORIZED =
        val === true ? "Y" : "N";
    } finally {
      setTableData([...newData]);
    }
  }

  //#region Table Columns
  const columns = [
    {
      accessorKey: "FEATURE_NAME",
      header: "Feature",
      size: 200,
    },
    {
      id: "FEATURE_TYPE_1",
      header: "Read",
      size: 60,
      accessorFn: (row) => {
        const detailR = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "R"
        );
        const detailW = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "W"
        );
        const existFlagR =
          row.PERMISSION_DETAILS.length > 0 ? detailR.length > 0 : false;
        const existFlagW =
          row.PERMISSION_DETAILS.length > 0 ? detailW.length > 0 : false;
        return (
          <>
            <Comp.Input
              id={`${row.FEATURE_NAME}_FEATURE_TYPE_1`}
              name="READ"
              type="checkbox"
              className=""
              disabled={
                !existFlagR ||
                (existFlagW ? detailW[0].AUTHORIZED === "Y" : false) ||
                !writeAuthority
              }
              checked={existFlagR ? detailR[0].AUTHORIZED === "Y" : false}
              onChange={(e) => checkBoxHandler(row, e.target.checked, "R")}
            />
          </>
        );
      },
    },
    {
      id: "FEATURE_TYPE_2",
      header: "Write",
      size: 60,
      accessorFn: (row) => {
        const detail = row.PERMISSION_DETAILS.filter(
          (d) => d.FEATURE_TYPE === "W"
        );
        const existFlag =
          row.PERMISSION_DETAILS.length > 0 ? detail.length > 0 : false;
        return (
          <>
            <Comp.Input
              id={`${row.FEATURE_NAME}_FEATURE_TYPE_2`}
              name="WRITE"
              type="checkbox"
              className=""
              disabled={!existFlag || !writeAuthority}
              checked={existFlag ? detail[0].AUTHORIZED === "Y" : false}
              onChange={(e) => checkBoxHandler(row, e.target.checked, "W")}
            />
          </>
        );
      },
    },
  ];
  //#endregion

  return (
    <>
      <Comp.VirtualTable
        columns={columns}
        data={tableData}
        enableRowSelection={false}
      />
    </>
  );
};

export default PAllowanceRate;
